// Payment panels images
import PP2 from "../assets/images/wallets/PSP2.png";
import PP6 from "../assets/images/wallets/creditcard.png";
import PP7 from "../assets/images/wallets/wallet_fill.png";

const showCashPayment = process.env.REACT_APP_CASH_PAYMENT === "true";

export const PAYMENT_PANELS = [
  {
    name: "pasargad",
    img: PP2,
    text: "بانک پاسارگاد",
  },
  ...(showCashPayment
    ? [
        {
          name: "cash",
          img: PP6,
          text: "پرداخت نقدی",
          description: process.env.REACT_APP_CASH_DESC,
        },
      ]
    : []),
];
console.log("Show Cash Payment:", showCashPayment);

export const SHAHRZAD_PAYMENT_PANELS = [
  {
    name: "pelican",
    img: PP6,
    text: "درگاه پرداخت",
  },
  {
    name: "pWallet",
    img: PP7,
    text: "کیف پول",
  },
  ...(showCashPayment
    ? [
        {
          name: "cash",
          img: PP6,
          text: "پرداخت نقدی",
          description: process.env.REACT_APP_CASH_DESC,
        },
      ]
    : []),
];

export const WEEK_DAYS = [
  "شنبه",
  "یکشنبه",
  "دو‌شنبه",
  "سه‌شنبه",
  "چهارشنبه",
  "پنجشنبه",
  "جمعه",
];
